import qs from 'query-string'

export const defaultParamsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'bracket' })
}
